// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.csi-components-dialog-DialogComponent-module-root {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
        align-items: center;
    padding: 16px;
}

.csi-components-dialog-DialogComponent-module-content {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-direction: column;
        flex-direction: column;
    gap: 16px;
    padding: 16px;
}

.csi-components-dialog-DialogComponent-module-icon {
    margin-right: 8px;
}

.csi-components-dialog-DialogComponent-module-message {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
        align-items: center;
    gap: 8px;
}

.csi-components-dialog-DialogComponent-module-buttons {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: end;
        justify-content: flex-end;
    gap: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/csi/components/dialog/DialogComponent.module.css"],"names":[],"mappings":"AAAA;IACI,oBAAa;IAAb,aAAa;IACb,sBAAmB;QAAnB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,oBAAa;IAAb,aAAa;IACb,0BAAsB;QAAtB,sBAAsB;IACtB,SAAS;IACT,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,oBAAa;IAAb,aAAa;IACb,sBAAmB;QAAnB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,oBAAa;IAAb,aAAa;IACb,kBAAyB;QAAzB,yBAAyB;IACzB,QAAQ;AACZ","sourcesContent":[".root {\n    display: flex;\n    align-items: center;\n    padding: 16px;\n}\n\n.content {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    padding: 16px;\n}\n\n.icon {\n    margin-right: 8px;\n}\n\n.message {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.buttons {\n    display: flex;\n    justify-content: flex-end;\n    gap: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `csi-components-dialog-DialogComponent-module-root`,
	"content": `csi-components-dialog-DialogComponent-module-content`,
	"icon": `csi-components-dialog-DialogComponent-module-icon`,
	"message": `csi-components-dialog-DialogComponent-module-message`,
	"buttons": `csi-components-dialog-DialogComponent-module-buttons`
};
module.exports = ___CSS_LOADER_EXPORT___;
